import React from "react";
import { Stack, Box } from "@mui/material";

import { ChannelCard, Loader } from "./";

const Channels = ({ channels, direction }) => {
  if(!channels?.length) return <Loader />;
  
  return (
    <Stack p={2} borderBottom= "solid gray 1px" flexDirection="row">
      <Stack direction={direction || "row"} flexWrap="wrap" justifyContent="start" alignItems="start" gap={2}>
        {channels.map((item, idx) => (
          <Box key={idx}>
            <ChannelCard channelDetail={item} />
          </Box>
        ))}
      </Stack>
    </Stack>
  );
}

export default Channels;